import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-success.png'


const _withScopeId = n => (_pushScopeId("data-v-5a812c05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-oc-reward-finish" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))

import { ColorVariants } from '@/constants';
  import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, _toDisplayString(_unref(t)('success_text')), 1),
    _createVNode(_component_router_link, {
      to: { name: 'home' },
      class: "link"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_button, {
          class: "btn-back",
          pill: "",
          variant: _unref(ColorVariants).outlinePrimary
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('offline_collection.back_to_home_page')), 1)
          ]),
          _: 1
        }, 8, ["variant"])
      ]),
      _: 1
    })
  ]))
}
}

})